import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getNormativeList,
	addNewNormative,
	updateNormative,
	deleteNormative,
	getNormative,
} from '../normative/thunk';

export const initialState = {
	itemNormativeList: [],
	itemNormativeDetail: null,
	isNormativeLoading: false,
	isNormativeSuccess: false,

	normativeList: [],
	normativeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const NormativeSlice = createSlice({
	name: 'Normatives',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getNormative.fulfilled, (state, action) => {
			state.isNormativeLoading = false;
			state.isNormativeSuccess = true;
			state.itemNormativeDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getNormative.pending, state => {
			state.isNormativeLoading = true;
			state.isNormativeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getNormative.rejected, (state, action) => {
			state.isNormativeLoading = false;
			state.isNormativeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getNormativeList.pending, state => {
			state.isNormativeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getNormativeList.fulfilled, (state, action) => {
			state.itemNormativeList = action.payload;
			state.normativeList = action.payload;
			state.isLoadingList = false;
			state.isNormativeSuccess = true;

			let normativeListSelect = [];
			action.payload.map(item =>
				normativeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.normativeListSelect = normativeListSelect;
		});
		builder.addCase(getNormativeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isNormativeSuccess = true;
		});
		builder.addCase(addNewNormative.fulfilled, (state, action) => {
			state.itemNormativeList.push(action.payload);
			state.normativeList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewNormative.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewNormative.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateNormative.fulfilled, (state, action) => {
			state.itemNormativeList = state.itemNormativeList.map(normative =>
				normative.normativename === action.payload.old_normative
					? { ...normative, ...action.payload.updated_normative }
					: normative
			);
			state.normativeList = state.normativeList.map(normative =>
				normative._id.toString() === action.payload._id.toString()
					? { ...normative, ...action.payload }
					: normative
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateNormative.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateNormative.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteNormative.fulfilled, (state, action) => {
			state.itemNormativeList = current(state.itemNormativeList).filter(
				item => item._id !== action.payload._id
			);
			state.normativeList = current(state.normativeList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteNormative.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteNormative.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = NormativeSlice.actions;

export default NormativeSlice.reducer;
